"use strict";

var React = require('react');
var ReactForms = require('react-forms');

var i18n = require('ofs/i18n');
var gettext = i18n.gettext;
var interpolate = i18n.interpolate;

var SelectOne = require('ofs/forms/inputs/simple-choice');

var settings = require('ofs/settings');

var Scalar = require('ofs/forms/scalars/Scalar');

var FormElement = ReactForms.Element;
var Row = require('ofs/forms/layout/row');
var Column = require('ofs/forms/layout/column');
var Group = require('ofs/forms/layout/group');

var messages = {
  // TODO: remove 'host questionnaire' link from `INTRO_PARAGRAPH` when new host questionnaire is rolled out
  INTRO_PARAGRAPH: gettext('To list with us please start on our page about becoming a onefinestay host. <a href="%(host_url)s">Read more</a> or take our <a href="%(questionnaire_url)s">host questionnaire</a>.'),
  INTRO_HEADING: gettext('Need to ask something else?'),
  LOCATION_LABEL: gettext('Location'),
  FOOTER_MESSAGE: gettext('Alternatively, contact our <b>%(city_name)s team</b> directly'),
  CONTACT_MESSAGE: gettext('<strong>%(phone_number)s</strong> or <a href="%(email_url)s">%(email_address)s</a>')
};

var locationOptions = [
  {value: 'LON', name: 'London'},
  {value: 'LAX', name: 'Los Angeles'},
  {value: 'NYC', name: 'New York'},
  {value: 'PAR', name: 'Paris'},
  {value: 'OTHER', name: 'Other'},
];


var mapping = function(defaultValues) {
  return {
    location: Scalar({
      type: 'string',
      input: <SelectOne options={locationOptions} />,
      defaultValue: defaultValues.get('cityCode', null),
      label: messages.LOCATION_LABEL
    })
  };
};

var layout = function(value) {
  var msg = interpolate(messages.INTRO_PARAGRAPH, {
    host_url: settings.urls['host-intro'],
    questionnaire_url: settings.urls['host-questionnaire']
  }, true);

  return (
    <Group>
      <Row>
        <Column size="full">
          <p dangerouslySetInnerHTML={{__html: msg}} />
          <h3>{messages.INTRO_HEADING}</h3>
        </Column>
      </Row>
      <Row>
        <Column size="full"><FormElement value={value.get('location')} /></Column>
      </Row>
    </Group>
  );
};


var Footer = React.createClass({
  render() {
    var footerMsg = interpolate(messages.FOOTER_MESSAGE, {
      city_name: this.props.cityName
    }, true);

    var contact = settings.cities[this.props.cityCode].contact;
    var contactMsg = interpolate(messages.CONTACT_MESSAGE, {
      phone_number: contact['hosts']['phone'],
      email_url: `mailto:${ contact['hosts']['email'] }`,
      email_address: contact['hosts']['email']
    }, true);

    return (
      <div className="ofs-InfoPanel u-text-center">
        <p dangerouslySetInnerHTML={{__html: footerMsg}} />
        <p dangerouslySetInnerHTML={{__html: contactMsg}} />
      </div>
    );
  }
});


module.exports = {mapping, layout, Footer};



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/contact/mappings/host.jsx
 **/